/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "sa-east-1",
    "aws_cognito_identity_pool_id": "sa-east-1:62570e71-ccbd-4b40-9192-b65ac08a10d9",
    "aws_cognito_region": "sa-east-1",
    "aws_user_pools_id": "sa-east-1_MyO4JOpDF",
    "aws_user_pools_web_client_id": "14a78n4dasljhcb0eoc2aphkoe",
    "oauth": {
        "domain": "qainiciante.auth.sa-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
            "redirectSignIn": "http://localhost:3002/login,https://www.qainiciante.com.br/",
            "redirectSignOut": "http://localhost:3002/login,https://www.qainiciante.com.br/",
            "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "meus-ebooks-comunidadee5af6-dev",
    "aws_user_files_s3_bucket_region": "sa-east-1"
};


export default awsmobile;
